import XHTTP from "services/api/xhttp";
import paths from "routes/paths";

class UserApi {
  static END_POINTS = {
    setFirstPassword: paths.api.users.setPassword,
    askForNewPassword: paths.api.users.forgotPassword,
    contractsConfig: paths.api.users.config.contracts,
    getBackofficeSettingsEndpoint: (id) =>
      paths.api.users.backoffice.settings.replace(":id", id),
  };

  static askForNewPassword(email) {
    return XHTTP(UserApi.END_POINTS.askForNewPassword, {
      method: "post",
      body: JSON.stringify({ email }),
      noAuth: true,
    });
  }

  static setFirstPassword(confirmToken, password) {
    return XHTTP(UserApi.END_POINTS.setFirstPassword, {
      method: "post",
      headers: { "X-Confirm-Token": confirmToken },
      body: JSON.stringify({ password }),
    });
  }

  static getContractsConfig() {
    return XHTTP(UserApi.END_POINTS.contractsConfig, {
      method: "get",
    });
  }

  static getBackofficeSettings(id) {
    return XHTTP(UserApi.END_POINTS.getBackofficeSettingsEndpoint(id), {
      method: "get",
    });
  }
}

export default UserApi;
